import { Component, OnInit } from '@angular/core';
import {CustomDashboardsService} from "app/modules/my-limegear/services/my-limegear.service";
import {NoDataActionType} from "app/modules/shared/interfaces/no-data";
import {ECloseService, IECloseCardInfo} from "app/modules/production/services/eClose.service";

@Component({
  selector: 'app-e-close-fundings-smc',
  templateUrl: './e-close-fundings-smc.component.html',
  styleUrls: ['./e-close-fundings-smc.component.scss']
})
export class ECloseFundingsSmcComponent implements OnInit {
  constructor(
      private _customDashboardsService: CustomDashboardsService,
      private _eCloseService: ECloseService,
  ) {}

  cardInfo: IECloseCardInfo;
  ngOnInit() {
    this.cardInfo = {
      cardId: 'eCloseFundings',
      urlSegment: 'loans-funded-by',
      uniqueId: 'eCloseFundings',
      title: 'eClose Fundings',
      dataType: 'number',
      type: 'small-card', 
      setRoiJson: '0',
    };
    let action = NoDataActionType.pageStart;
    this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
      this.cardInfo.card = this._eCloseService.initializeECloseSmallCard(this.cardInfo, action);      
      this.cardInfo.card.routerLink = '/reporting/production';    
      
      this._eCloseService.updateCard(
          this.cardInfo,
          changes.displayOptions,
          changes.hierarchyfilters,
          changes.action
      );
    });
  }
}
